import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MessageBoxComponent } from './message-box/message-box';

@Injectable()
export class ModalDialog {
   constructor(private dialog: MatDialog) { }

   open<T, D = any, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
                             config?: MatDialogConfig<D>,
                             afterClosed?: (value: R | undefined) => void): MatDialogRef<T, R> {
      if (!config) {
         config = { disableClose: true };
      } else if (config.disableClose === undefined) {
         config.disableClose = true;
      }
      const dialogRef = this.dialog.open(componentOrTemplateRef, config);
      if (afterClosed) {
         dialogRef.afterClosed().subscribe(afterClosed);
      }
      return dialogRef;
   }

   msg(data: any): MatDialogRef<MessageBoxComponent> {
      return this.dialog.open(MessageBoxComponent, { disableClose: true, data });
   }
}
